import { BreadcrumbItem } from './breadcrumb-item';

export interface BreadcrumbData {
  breadcrumb?: BreadcrumbItem[];
  breadcrumbStage?: number;
}
